module.exports = __webpack_public_path__ + "lr.5fbbdd2c2e7a48413408.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/lr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/lr.svg
// module chunks = styles